import { Log } from '../../types/utils/common'

export const getLogInfo = (log?: Log | null) => {
  const logKeys = log ? Object.keys(log).map(key => parseInt(key, 10)) : undefined
  let lastUpdatedKey
  let lastCreatedKey
  let lastUpdated
  let lastCreated
  if (log) {
    lastUpdatedKey = logKeys?.sort(
      (a: number, b: number) => (log[b]?.updatedOn ?? b) - (log[a]?.updatedOn ?? a),
    )[0]
    lastCreatedKey = logKeys?.sort((a, b) => b - a)[0]
    if (lastUpdatedKey) lastUpdated = log[lastUpdatedKey]
    if (lastCreatedKey) lastCreated = log[lastCreatedKey]
  }

  return {
    lastCreated,
    lastUpdated,
    lastCreatedKey,
    lastUpdatedKey,
  }
}

export const getLogSnippet = (log?: Log | null): Log | null => {
  const { lastCreated, lastCreatedKey } = getLogInfo(log)
  return lastCreated && lastCreatedKey ? { [lastCreatedKey]: lastCreated } : null
}
